import { PropsWithChildren } from "react"
import { makeStyles } from "tss-react/mui"
import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { Tooltip } from "@mui/material"

const useStyles = makeStyles()((theme) => ({}))

type EventTooltipProps = Readonly<PropsWithChildren<{}>>

export function EventTooltip({ children }: EventTooltipProps) {
    const { classes } = useStyles()

    return (
        <LocalizedStrict id="create-order-calendar-event-tooltip" attrs={{ title: true }}>
            <Tooltip title="Click to book">
                <span>{children}</span>
            </Tooltip>
        </LocalizedStrict>
    )
}
